import React, { useState } from "react";
import MediaListing from "./MediaListing";
import SubCategoryManagment from "./SubCategoryManagment";
import CategoryManagment from "./CategoryManagment";

export default function MediaManagment() {
  const [activeTab, setActiveTab] = useState("media_listing");
  return (
    <>
      <div className="graph-btns tabs">
        <button
          className={activeTab === "media_listing" ? "active" : ""}
          onClick={() => setActiveTab("media_listing")}
        >
          Media List
        </button>

        <button
          className={activeTab === "sub-category" ? "active" : ""}
          onClick={() => setActiveTab("sub-category")}
        >
          Sub-Category List
        </button>
      </div>
      <div className="chart-blk mt-2">
        {activeTab === "media_listing" && <MediaListing />}
        {activeTab === "category" && <CategoryManagment />}
        {activeTab === "sub-category" && <SubCategoryManagment />}

      </div>
    </>
  );
}
